import "./FreeFranceDirectory.module.css";
import Header from "@/reusable_sections/Header";
import DirectoryListing from "./sections/DirectoryListing";
import DownloadCta from "./sections/DownloadCta";
import Footer from "@/reusable_sections/Footer";
export default function FreeFranceDirectoryPage() {
  return <div>
      <Header />
      <DirectoryListing />
      <DownloadCta />
      <Footer />
    </div>;
}